import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import IForgotPasswordText from "@/domain/dto/forgot-password-text.interface";
import { SubmitType } from "@/domain/enums/submit-type";
import { computed, Ref } from "vue";

export default class ForgotPassword {
	public submitType = SubmitType.RESET_PASSWORD;

	public emailSent = computed((): boolean => {
		return this.store.getters.resetPasswordEmailSent();
	});

	public text = computed((): IForgotPasswordText => {
		if (!this.emailSent.value) {
			return {
				header: 'Forgot password?',
				message: 'Enter your email and we’ll send you a password reset link',
			};
		}
		return {
			header: 'Check your email',
			message: 'If an account exists for that email address, we’ve sent password reset instructions',
		};
	});

	constructor(public store: IIncentiveV2Store, private readonly isForgotPassword: Ref<boolean>) {}

	public async requestReset(): Promise<void> {
		await this.store.actions.forgotPassword();
	}

	public backToLogin(): void {
		this.store.mutations.setErrorMessage({ message: null, type: null });
		this.isForgotPassword.value = false;
	}
}
